/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { TouchableOpacity, View } from "react-native";

import Rodal from "rodal";
import "rodal/lib/rodal.css";
import Icon from "react-icons-kit";
import { ic_close } from "react-icons-kit/md/ic_close";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { Text } from "UpduoLibrary";
import {
  skaleBlack,
  skalePrimaryBlue,
  skaleTextBlue,
  skaleDeactiveGray,
  colorWithOpacity,
} from "config/UpduoColors";
import * as UpduoAnalytics from "config/UpduoAnalytics";

interface TechnicalSupportModalProps {
  isVisible: boolean;
  onClose: Function;
}

export default function TechnicalSupportModal({
  isVisible,
  onClose,
}: TechnicalSupportModalProps) {
  const technicalSupportInfo = [
    {
      support: "I can't see my partner",
      answer:
        "Make sure you don't have Zoom or another application/browsertab open that requires your camera. If you do, please close them and refresh this page.",
    },
    {
      support: "I can't hear my partner",
      answer:
        "If you're using wireless headphones, make sure your Bluetooth connection is working properly, or disconnect them and use your computer's built-in audio instead.",
    },
    {
      support: "My partner can't hear me",
      answer:
        "Make sure that you have given Upduo access to your microphone. If you have, the issue might be with your partner's Bluetooth. If they continue to have issues, please end this session and connect with a new partner.",
    },
  ];

  return (
    <Rodal
      visible={isVisible}
      onClose={() => onClose()}
      customStyles={{
        height: "fit-content",
        width: 750,
        borderRadius: 12,
      }}
      customMaskStyles={{
        backgroundColor: colorWithOpacity(skaleDeactiveGray, 0.2),
      }}
    >
      <View
        style={{
          alignItems: "center",
          justifyContent: "center",
          margin: 20,
        }}
      >
        {technicalSupportInfo.map(function (item) {
          return (
            <Accordion
              key={item.support}
              style={{
                boxShadow: "none",
                margin: "0 auto",
              }}
            >
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon
                    style={{ color: skalePrimaryBlue, fontSize: 25 }}
                  />
                }
                style={{
                  minHeight: 65,
                  marginTop: -1,
                  // Don't show topborder if first item
                  borderTop:
                    item !== technicalSupportInfo[0]
                      ? "1px solid #E0E0E0"
                      : "1px solid white",
                }}
                onClick={() =>
                  UpduoAnalytics.logEvent("user-click-help-item", {
                    support: item.support,
                  })
                }
              >
                <Text
                  isHeading={true}
                  style={{
                    fontSize: 16,
                    color: skaleBlack,
                  }}
                >
                  {item.support}
                </Text>
              </AccordionSummary>
              <AccordionDetails>
                <Text
                  style={{
                    fontSize: 16,
                    color: skaleBlack,
                  }}
                >
                  {item.answer}
                </Text>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </View>
      <View style={{ position: "absolute", top: 0, right: 0 }}>
        <TouchableOpacity
          onPress={() => {
            onClose();
          }}
          style={{
            paddingTop: 16,
            paddingRight: 16,
            alignSelf: "flex-end",
          }}
        >
          <div
            style={{
              color: skaleTextBlue,
              paddingBottom: 2.5,
            }}
          >
            <Icon size={25} icon={ic_close} />
          </div>
        </TouchableOpacity>
      </View>
    </Rodal>
  );
}
